import { gql } from '@apollo/client';

import { FillInTheBlanksExercise } from '../../types';
import { fillInTheBlanksExerciseFragment } from '../fragments';

export interface GetFillInTheBlanksExerciseQueryVariables {
  courseId: string;
  subjectId: string;
  exerciseId?: string;
}

export interface GetFillInTheBlanksExerciseQueryResult {
  fillInTheBlanksExercise: FillInTheBlanksExercise;
}

export const getFillInTheBlanksExerciseQuery = gql`
  query GetFillInTheBlanksExerciseQuery($courseId: String!, $subjectId: String!, $exerciseId: String!) {
    fillInTheBlanksExercise(courseId: $courseId, subjectId: $subjectId, exerciseId: $exerciseId)
      @rest(type: "Exercise", path: "courses/{args.courseId}/subjects/{args.subjectId}/exercises/{args.exerciseId}") {
      ...FillInTheBlanksExercise
    }
  }
  ${fillInTheBlanksExerciseFragment}
`;
